import React, { Component } from 'react'
import Helmet from 'react-helmet'

import SectionWhoWeAre from '@/section-who-we-are'
import SectionMeetOutTeam from '@/section-meet-out-team'

import shareImg from './images/who_we_are.png'

class WhoWeAre extends Component {
  render() {
    const { data } = this.props

    return (
      <div>
        <Helmet>
          <title>Who we are</title>
          <meta property="og:title" content="Who we are" />
          <meta property="og:description" content="We are a team of experts in digital turnkey solutions for beauty pageants" />
          <meta property="og:image" content={`https://nextmiss.com${shareImg}`} />
          <meta property="og:url" content="https://nextmiss.com/who_we_are/" />
          <meta property="og:image:alt" content="Who we are - Next Miss" />
        </Helmet>

        <SectionWhoWeAre data={data} />
        <SectionMeetOutTeam data={data} />
      </div>
    )
  }
}

export default WhoWeAre

export const query = graphql`
  query WhoWeAreQuery {
    Christina: imageSharp(id: { regex: "/Christina/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    Kaius: imageSharp(id: { regex: "/Kaius/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    Matti: imageSharp(id: { regex: "/Matti/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    Visa: imageSharp(id: { regex: "/Visa/" }) {
      sizes(maxWidth: 60) {
        ...GatsbyImageSharpSizes
      }
    }
    ourValuesBg: imageSharp(id: { regex: "/ourValuesBg/" }) {
      sizes(maxWidth: 500) {
        ...GatsbyImageSharpSizes
      }
    }
    ourVisionBg: imageSharp(id: { regex: "/ourVisionBg/" }) {
      sizes(maxWidth: 500) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/who_we_are.js